// Angular 19's build tooling (webpack 5) no longer auto-polyfills the Node.js
// `global` identifier. zone.js 0.15.x references `global` directly at
// module-evaluation time, and ES import hoisting means any sibling static
// import (e.g. `import 'zone.js'`) in polyfills.ts always evaluates before
// that file's own top-level statements, regardless of source position. This
// must be the FIRST static import in polyfills.ts so it runs before zone.js.
(window as any).global = window;
